interface LockGrantedCallback<T> {
    (): T;
}

export async function requestLock<T>(name: string, callback: LockGrantedCallback<T>): Promise<T> {
    if(navigator.locks && navigator.locks.request) {
        return navigator.locks.request(name, callback)
    }
    /*                   */
    const polyfill = await import("./requestLockPolyfill.ts")
    return polyfill.lockManager.request(name, callback)
}
